import { createTheme,
  height,
  styled } from '@mui/system';
import { emulatorScreen, laptopScreen, mobileScreen } from '../../utils/index.js';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { Grid, Typography } from "@mui/material";
import { Slider  } from '@mui/joy';


// Create a theme instance
const theme = createTheme();
export default {
  mainGrid: styled(Grid)({
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      // height: 25
    },
  }),
  QuestionMarkers: styled(QuestionMarkIcon)({
    fontSize: 16,
    fontWeight: 700,
    background: "#3b3b3b",
    borderRadius: "50%",
    color: "#fff",
    [emulatorScreen(theme)]: {
      fontSize: 14,
    },
    [mobileScreen(theme)]: {
      fontSize: 8,
    },
  }),

  LabelText: styled(Typography)({
    fontFamily: "Rubik",
    color: "#003E4C",
    fontSize: 16,
    lineHeight: 1.2,
    [emulatorScreen(theme)]: {
      fontSize: 14,
    },
    [laptopScreen(theme)]: {
      fontSize: 12,
    },
    [mobileScreen(theme)]: {
      fontSize: 8,
      minHeight: 25
    },
  }),

  PercentageText: styled(Typography)({
    color: '#003E4C',
    fontSize: 20,
    fontFamily: 'Rubik',
    [emulatorScreen(theme)]: {
      fontSize: 14,
    },
    [mobileScreen(theme)]: {
      fontSize: 12,
    },
  }),

  Slider: styled(Slider)({
    "--Slider-trackBackground": "#D9D9D9",
    "--Slider-color": "red",
    "--Slider-thumbSize": "40px",
    "--Slider-thumbRadius": "5px",
    "--Slider-thumbRadiusColor": "red",
    "--Slider-thumbWidth": "20px",
    "--Slider-trackSize": "20px",
    "--Slider-railBackground": "#D9D9D9",
    [emulatorScreen(theme)]: {
      "--Slider-thumbSize": "30px",
      "--Slider-thumbRadius": "5px",
      "--Slider-thumbWidth": "15px",
      "--Slider-trackSize": "15px",
    },
    [mobileScreen(theme)]: {
      "--Slider-thumbSize": "20px",
      "--Slider-thumbRadius": "5px",
      "--Slider-thumbWidth": "10px",
      "--Slider-trackSize": "10px",
    },
  })


  // sx={{ "--Slider-trackBackground": color,
  //   "--Slider-color": "red",
  //   "--Slider-thumbSize": "40px",
  //   "--Slider-thumbRadius": "5px",
  //   "--Slider-thumbRadiusColor": "red",
  //   "--Slider-thumbWidth": "20px",
  //   "--Slider-trackSize": "20px",
  //   "--Slider-railBackground": "#D9D9D9"}}
}